import React from "react";
import About from "../../components/About";
import Courses from "../../components/Courses";
import Credential from "../../components/Credential";
import Positions from "../../components/Positions";
import Profile from "../../components/Profile";
import Projects from "../../components/Projects";
import TechStack from "../../components/TechStack";

const Home = () => {
  return (
    <div className="home">
      <Profile />
      <About />
      <div className="postion-credential-courses-wrapper">
        <Positions />
        <Courses />
        <Credential />
      </div>
      <TechStack />
      <Projects />
    </div>
  );
};

export default Home;
